import { CollapseProps } from "antd";
import { Translation } from "react-i18next";

export const newBankPoolCollapse = (children : any): CollapseProps['items'] => [
    {
      key: '1',
      label: <Translation> 
      {
          t => t("forms.questions.advSettings")
      }
      </Translation>,
      children: children,
    },
  ];